import 'antd/dist/reset.css';
import { createBrowserHistory } from 'history';
import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import UserProvider from 'src/context/UserContext';
import { App } from '../app/App';
// import { LoginForm } from '../loginForm/LoginForm';
import './style.css';
import LatestLogin from '../loginForm/LatestLogin';
import DateRangeProvider from 'src/context/DateRangeContext';
import { Toaster } from 'react-hot-toast';

export const browserHistory = createBrowserHistory();

export const Root: React.FC = () => (
    <UserProvider>
        <DateRangeProvider>

                <Toaster position="top-right" reverseOrder={false} />
            <Switch>
                {/* <Route path="/login" component={LoginForm} /> */}
                <Route path="/login" component={LatestLogin} />
                <Route path="/" component={App} />

            </Switch>
        </DateRangeProvider>
    </UserProvider>
)
